//client/src/components/NotificationBell.js
import { Bell } from "lucide-react";
import { useEffect, useState } from "react";
import api from "../api/axiosInstance";
import { useSocket } from "../context/SocketContext";

export default function NotificationBell() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const { socket } = useSocket();

  const load = async () => {
    const res = await api.get("/user/notifications");
    setList(res.data || []);
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    if (!socket) return;

    socket.on("notification", (n) => {
      setList((prev) => [n, ...prev]);
    });

    return () => socket.off("notification");
  }, [socket]);

  const unread = list.filter((n) => !n.read).length;

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="relative p-2 rounded-full hover:bg-white/10"
      >
        <Bell size={18} />
        {unread > 0 && (
          <span className="absolute top-1 right-1 w-2 h-2 bg-purple-500 rounded-full" />
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-3 w-80 bg-[#0b0f17] border border-white/10 rounded-xl shadow-xl z-50">
          <div className="px-4 py-3 border-b border-white/10 font-semibold">
            Notifications
          </div>

          <div className="max-h-72 overflow-y-auto">
            {list.length === 0 && (
              <p className="p-4 text-sm text-gray-400">No notifications</p>
            )}

            {list.map((n) => (
              <div
                key={n._id}
                className="px-4 py-3 text-sm border-b border-white/5 hover:bg-white/5"
              >
                <b>{n.title}</b>
                <p className="text-gray-400">{n.message}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
